import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
const apiUrl = import.meta.env.VITE_API_URL;

const ProductCategoryList3 = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [activeCat, setActiveCat] = useState({});

  useEffect(() => {
    axios.get(`${apiUrl}/api/categories`).then(response => setCategories(response.data));
    axios.get(`${apiUrl}/api/subcategories`).then(response => setSubcategories(response.data));
    const categorySlug = searchParams.get('category_slug');
    const subcategorySlug = searchParams.get('subcategory_slug');
    setSelectedCategory(categorySlug);
    setSelectedSubcategory(subcategorySlug);
  }, [searchParams]);

  const handleCategoryClick = (category) => {
    const currentParams = new URLSearchParams(searchParams);
    currentParams.delete('subcategory_slug');
    currentParams.set('category_slug', category.slug);
    setSelectedCategory(category.slug);
    setSelectedSubcategory(null);
    navigate(`/products/category/${category.slug}?${currentParams.toString()}`);
  };

  const handleSubcategoryClick = (subcategory) => {
    const currentParams = new URLSearchParams(searchParams);
    currentParams.delete('category_slug');
    currentParams.set('subcategory_slug', subcategory.slug);
    setSelectedSubcategory(subcategory.slug);
    setSelectedCategory(null);
    navigate(`/products/subcategory/${subcategory.slug}?${currentParams.toString()}`);
  };

  const getCategorySubcategories = (categoryId) => {
    return subcategories.filter(subcategory => subcategory.category_id === categoryId);
  };

  const toggleActiveCat = (category) => {
    setActiveCat((prevState) => ({
      ...prevState,
      [category.id]: !prevState[category.id],
    }));
  };

  return (
    <div className="sidebar-single-area">
      <h3 className="sidebar-single-area__title">{t('Category')}</h3>
      <ul className="product-categories categories">
        {categories.map((category) => (
          <li className="cat-item" key={category.id}>
            <a
              href="#"
              className={`has-sub ${activeCat[category.id] ? 'open' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                toggleActiveCat(category);
                handleCategoryClick(category);
              }}
            >
              {i18n.language === 'ar' ? category.name_ar : category.name_en}
            </a>
            <ul className={`product-categories ${activeCat[category.id] ? 'd-block' : 'd-none'}`}>
              {getCategorySubcategories(category.id).map((subcategory) => (
                <li className="cat-item" key={subcategory.id}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSubcategoryClick(subcategory);
                    }}
                  >
                    {i18n.language === 'ar' ? subcategory.name_ar : subcategory.name_en}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductCategoryList3;